"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZeroXData = exports.createZeroXUrlAndHeaders = exports.zeroXApiSubdomain = exports.ZeroXApiEndpoint = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const axios_1 = __importDefault(require("axios"));
const zero_x_config_1 = require("../../models/zero-x-config");
var ZeroXApiEndpoint;
(function (ZeroXApiEndpoint) {
    ZeroXApiEndpoint["GetSwapQuote"] = "swap/v1/quote";
})(ZeroXApiEndpoint = exports.ZeroXApiEndpoint || (exports.ZeroXApiEndpoint = {}));
const zeroXApiSubdomain = (networkName) => {
    switch (networkName) {
        case shared_models_1.NetworkName.Ethereum:
            return 'api';
        case shared_models_1.NetworkName.BNBChain:
            return 'bsc.api';
        case shared_models_1.NetworkName.Polygon:
            return 'polygon.api';
        case shared_models_1.NetworkName.Arbitrum:
            return 'arbitrum.api';
        case shared_models_1.NetworkName.EthereumGoerli:
            return 'goerli.api';
        case shared_models_1.NetworkName.PolygonMumbai:
            return 'mumbai.api';
        case shared_models_1.NetworkName.ArbitrumGoerli:
        case shared_models_1.NetworkName.Railgun:
        case shared_models_1.NetworkName.Hardhat:
        case shared_models_1.NetworkName.EthereumRopsten_DEPRECATED:
            throw new Error(`No 0x API URL for chain ${networkName}`);
    }
};
exports.zeroXApiSubdomain = zeroXApiSubdomain;
const zeroXApiUrl = (networkName) => {
    return `https://${(0, exports.zeroXApiSubdomain)(networkName)}.0x.org`;
};
const paramString = (params) => {
    if (!params) {
        return '';
    }
    const searchParams = new URLSearchParams(params);
    return searchParams.toString() ? `?${searchParams.toString()}` : '';
};
const createZeroXUrlAndHeaders = (endpoint, networkName, isRailgun, params) => {
    const proxyDomain = zero_x_config_1.ZeroXConfig.PROXY_API_DOMAIN;
    if ((0, shared_models_1.isDefined)(proxyDomain) && proxyDomain.length > 0) {
        return {
            url: createZeroXProxyAPIUrl(proxyDomain, endpoint, networkName, isRailgun, params),
            headers: {},
        };
    }
    const apiKey = zero_x_config_1.ZeroXConfig.API_KEY;
    if ((0, shared_models_1.isDefined)(apiKey) && apiKey.length > 0) {
        const url = `${zeroXApiUrl(networkName)}/${endpoint}${paramString(params)}`;
        return { url, headers: { '0x-api-key': apiKey } };
    }
    throw new Error('No 0x proxy domain or API Key configured. Set ZeroXConfig.PROXY_API_DOMAIN or ZeroXConfig.API_KEY. For tests, modify test-config-overrides.test.ts.');
};
exports.createZeroXUrlAndHeaders = createZeroXUrlAndHeaders;
const createZeroXProxyAPIUrl = (proxyDomain, endpoint, networkName, isRailgun, params) => {
    const route = isRailgun ? 'railgun' : 'public';
    const url = `${proxyDomain}/0x/${route}/${(0, exports.zeroXApiSubdomain)(networkName)}/${endpoint}${paramString(params)}`;
    return url;
};
const getZeroXData = async (endpoint, networkName, isRailgun, params) => {
    const { url, headers } = (0, exports.createZeroXUrlAndHeaders)(endpoint, networkName, isRailgun, params);
    const rsp = await axios_1.default.get(url, { headers });
    return rsp.data;
};
exports.getZeroXData = getZeroXData;
